import React, { Component } from 'react'
import TextField from 'material-ui/TextField';
import { connect } from 'react-redux'
import { api } from "../../../../../../api/index"
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import {loadImages, resetImages} from "../../../../../../api/images";
import {getTopics} from "../../../../../../api/topics";


class PromotionGeneralStreamComponent extends Component {
	constructor(props) {
		super(props);

		this.handlePositionFieldState = this.handlePositionFieldState.bind(this);
	}

	handlePositionFieldState(event) {

		const target = event.target;
		const name = target.name;
		const value = target.value;

		api.promotions.handlePositionFieldState( name, value, this.props.periodKey, this.props.variantKey );
	}

	componentDidMount() {
		resetImages().then( () => {
			loadImages([
				{
					width: 214,
					height: 156,
				}
			]);
		});

		getTopics();
	}

	renderTopics() {
		const { topics } = this.props;

		topics.data.sort(function(a,b) {return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);} );

		return topics.data.map( ( topic, index ) =>
			<MenuItem key={index} value={topic.key} primaryText={topic.name} />
		)
	}

	handleTopicChange(event, index, value) {
		api.promotions.handleState( 'topicIds', value);
	}

	render() {
		return (
			<div className="grid-x grid-margin-y grid-margin-x">
				<div className="medium-6 cell">
					<label>
						Koppelen aan topics
						<SelectField
							floatingLabelText="Topics"
							value={this.props.promotion.topicIds}
							fullWidth={true}
							onChange={this.handleTopicChange}
							multiple={true}
						>
							{this.renderTopics()}
						</SelectField>
					</label>
				</div>
			</div>
		);
	}
}

const mapStateToProps = ( state ) => {
	return {
		promotion: state.promotion,
		topics: state.topics,
	}
};

export default connect(mapStateToProps, {
	loadImages,
	resetImages,
	getTopics
})(PromotionGeneralStreamComponent)


// WEBPACK FOOTER //
// ./src/application/components/promotions/components/types/general/stream.js